
export class Log {
    Id: number = 0;
    App: string = "";
    Metodo: string = "";
    Params: string = "";
    Mensaje: string = "";
    Usuario: string = "";
    Fecha: Date = new Date();
    Nivel: string = "";
}